exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".office-contact-info{margin-bottom:24px;font-size:12px}@media (max-width:992px){.office-contact-info{text-align:center}.office-contact-info>.col-md-2{margin-bottom:8px}}.office-contact-info-icon{width:32px;height:32px;border:1px solid #fff;border-radius:50%;margin:10px;line-height:32px;text-align:center;font-size:18px}.office-contact-info-icon:first-of-type{margin-left:0}.office-contact-info-icon:hover{text-decoration:none}.office-contact-info-text-row{display:inline-block;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
